// extracted by mini-css-extract-plugin
export default {"button":"loginForm_button__-Tzsj","errorDiv":"loginForm_errorDiv__WTSkQ","input":"loginForm_input__GEiRA","form":"loginForm_form__ctCI-"};